function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"],
  _excluded2 = ["scope", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var $4O1Ne$react = require("react");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "createContext", function () {
  return $dec3cc0142d4f286$export$fd42f52fd3ae1109;
});
$parcel$export(module.exports, "createContextScope", function () {
  return $dec3cc0142d4f286$export$50c7b4e9d9f19c1;
});
function $dec3cc0142d4f286$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
  var Context = /*#__PURE__*/$4O1Ne$react.createContext(defaultContext);
  function Provider(props) {
    var children = props.children,
      context = _objectWithoutProperties(props, _excluded); // Only re-memoize when prop values change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var value = $4O1Ne$react.useMemo(function () {
      return context;
    }, Object.values(context));
    return /*#__PURE__*/$4O1Ne$react.createElement(Context.Provider, {
      value: value
    }, children);
  }
  function useContext(consumerName) {
    var context = $4O1Ne$react.useContext(Context);
    if (context) return context;
    if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
  }
  Provider.displayName = rootComponentName + 'Provider';
  return [Provider, useContext];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/
function $dec3cc0142d4f286$export$50c7b4e9d9f19c1(scopeName) {
  var createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultContexts = [];
  /* -----------------------------------------------------------------------------------------------
  * createContext
  * ---------------------------------------------------------------------------------------------*/
  function $dec3cc0142d4f286$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    var BaseContext = /*#__PURE__*/$4O1Ne$react.createContext(defaultContext);
    var index = defaultContexts.length;
    defaultContexts = [].concat(_toConsumableArray(defaultContexts), [defaultContext]);
    function Provider(props) {
      var scope = props.scope,
        children = props.children,
        context = _objectWithoutProperties(props, _excluded2);
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
      // eslint-disable-next-line react-hooks/exhaustive-deps
      var value = $4O1Ne$react.useMemo(function () {
        return context;
      }, Object.values(context));
      return /*#__PURE__*/$4O1Ne$react.createElement(Context.Provider, {
        value: value
      }, children);
    }
    function useContext(consumerName, scope) {
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var context = $4O1Ne$react.useContext(Context);
      if (context) return context;
      if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
      throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [Provider, useContext];
  }
  /* -----------------------------------------------------------------------------------------------
  * createScope
  * ---------------------------------------------------------------------------------------------*/
  var createScope = function createScope() {
    var scopeContexts = defaultContexts.map(function (defaultContext) {
      return /*#__PURE__*/$4O1Ne$react.createContext(defaultContext);
    });
    return function useScope(scope) {
      var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $4O1Ne$react.useMemo(function () {
        return _defineProperty({}, "__scope".concat(scopeName), _objectSpread(_objectSpread({}, scope), {}, _defineProperty({}, scopeName, contexts)));
      }, [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [$dec3cc0142d4f286$export$fd42f52fd3ae1109, $dec3cc0142d4f286$var$composeContextScopes.apply(void 0, [createScope].concat(_toConsumableArray(createContextScopeDeps)))];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/
function $dec3cc0142d4f286$var$composeContextScopes() {
  for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
    scopes[_key] = arguments[_key];
  }
  var baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  var createScope1 = function createScope1() {
    var scopeHooks = scopes.map(function (createScope) {
      return {
        useScope: createScope(),
        scopeName: createScope.scopeName
      };
    });
    return function useComposedScopes(overrideScopes) {
      var nextScopes1 = scopeHooks.reduce(function (nextScopes, _ref2) {
        var useScope = _ref2.useScope,
          scopeName = _ref2.scopeName;
        // We are calling a hook inside a callback which React warns against to avoid inconsistent
        // renders, however, scoping doesn't have render side effects so we ignore the rule.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var scopeProps = useScope(overrideScopes);
        var currentScope = scopeProps["__scope".concat(scopeName)];
        return _objectSpread(_objectSpread({}, nextScopes), currentScope);
      }, {});
      return $4O1Ne$react.useMemo(function () {
        return _defineProperty({}, "__scope".concat(baseScope.scopeName), nextScopes1);
      }, [nextScopes1]);
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}